var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgThumbtack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#63430B",
    d: "M1.25322006,1.25 C1.25322006,0.55859375 1.81181381,0 2.50322006,0 L12.5032201,0 C13.1946263,0 13.7532201,0.55859375 13.7532201,1.25 C13.7532201,1.94140625 13.1946263,2.5 12.5032201,2.5 L11.3508763,2.5 L11.7961888,8.2890625 C13.2297826,9.06640625 14.3625951,10.3671875 14.9016576,11.9882812 L14.9407201,12.1054688 C15.0696263,12.4882812 15.0032201,12.90625 14.7688451,13.2304688 C14.5344701,13.5546875 14.1555638,13.75 13.7532201,13.75 L1.25322006,13.75 C0.85087631,13.75 0.47587631,13.5585938 0.23759506,13.2304688 C-0.000686190439,12.9023437 -0.0631861904,12.484375 0.0657200596,12.1054688 L0.10478256,11.9882812 C0.64384506,10.3671875 1.77665756,9.06640625 3.21025131,8.2890625 L3.65556381,2.5 L2.50322006,2.5 C1.81181381,2.5 1.25322006,1.94140625 1.25322006,1.25 Z M6.25322006,15 L8.75322006,15 L8.75322006,18.75 C8.75322006,19.4414062 8.19462631,20 7.50322006,20 C6.81181381,20 6.25322006,19.4414062 6.25322006,18.75 L6.25322006,15 Z",
    transform: "scale(-1 1) rotate(45 -3.166 -12.342)"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbtack);
export default __webpack_public_path__ + "static/media/thumbtack.ff26d3b7fb07b6879e398ed67ceeb222.svg";
export { ForwardRef as ReactComponent };